import { matchTypesEnum, matchTypesFromAmazon } from "../../../../types/customers"
import { IMaxTargetCPCByType } from "../../../../types/settings"
import { campaignTagsEnum } from "../../types/placement"
import { ICampaign, IDefaultTargetAcos } from "../../types/sponsoredProducts"

export const DEFAULT_CAMPAIGN_TARGET_ACOS = 30

const ACOS_TYPE_BY_MATCH_TYPE: Partial<Record<matchTypesFromAmazon, matchTypesEnum>> = {
  [matchTypesFromAmazon.ASIN]: matchTypesEnum.ASIN,
  [matchTypesFromAmazon.PHRASE]: matchTypesEnum.PHRASE,
  [matchTypesFromAmazon.BROAD]: matchTypesEnum.BROAD,
  [matchTypesFromAmazon.OTHER]: matchTypesEnum.ALL_OTHER,
  [matchTypesFromAmazon.EXACT]: matchTypesEnum.EXACT,
  [matchTypesFromAmazon.AUTO]: matchTypesEnum.AUTO,
  [matchTypesFromAmazon.INCOMPLETE]: matchTypesEnum.ALL_OTHER,
}

const MAX_CPC_KEY_BY_ACOS_TYPE: Partial<Record<matchTypesEnum, keyof IMaxTargetCPCByType>> = {
  [matchTypesEnum.EXACT]: "exactRanking",
  [matchTypesEnum.PHRASE]: "phrase",
  [matchTypesEnum.BROAD]: "broad",
  [matchTypesEnum.AUTO]: "auto",
  [matchTypesEnum.ASIN]: "asin",
}

const isRankingCampaign = (campaign: ICampaign | undefined): boolean =>
  !!campaign?.tags?.includes(campaignTagsEnum.RANKING)

export function findDefaultTargetAcos(
  campaign: ICampaign | undefined,
  defaultTargetAcos: IDefaultTargetAcos[] | undefined
): IDefaultTargetAcos | undefined {
  if (!campaign) {
    return undefined
  }
  const type = ACOS_TYPE_BY_MATCH_TYPE[campaign.matchType]
  const ranking = isRankingCampaign(campaign)

  return (defaultTargetAcos ?? []).find(
    (row) => row.type === type || (ranking && row.type === matchTypesEnum.RANKING)
  )
}

export function resolveInheritedCampaignTargetAcos(
  campaign: ICampaign | undefined,
  defaultTargetAcos: IDefaultTargetAcos[] | undefined
): number {
  const settingsAcos = findDefaultTargetAcos(campaign, defaultTargetAcos)?.TOStargetAcos
  return settingsAcos && settingsAcos > 0 ? settingsAcos : DEFAULT_CAMPAIGN_TARGET_ACOS
}

export function resolveMaxTargetCpc(
  campaign: ICampaign | undefined,
  globalMaxTargetCpc: number,
  maxTargetCPCByType: Partial<IMaxTargetCPCByType> | null | undefined
): number {
  const acosType = campaign && ACOS_TYPE_BY_MATCH_TYPE[campaign.matchType]
  const key = isRankingCampaign(campaign)
    ? "exactRanking"
    : acosType && MAX_CPC_KEY_BY_ACOS_TYPE[acosType]
  const perTypeMax = key ? Number(maxTargetCPCByType?.[key]) : 0
  return perTypeMax > 0 ? perTypeMax : globalMaxTargetCpc
}
